import { Flex, Tag } from '@chakra-ui/react';

const dividerColors = [
  '#FF7452',
  '#FFC400',
  '#57D9A3',
  '#00C7E6',
  '#2684FF',
  '#8777D9',
  '#999999',
];

export const PositionTag = ({ position }: { position: number }) => {
  function getColorForLine(lineNumber: number): string {
    return dividerColors[(lineNumber - 1) % dividerColors.length];
  }

  const getBgColor = () => {
    if (position === 1) {
      return 'bloodMoon.100';
    }
    if (position < 21) {
      return 'white.80';
    }
    return 'white.10';
  };
  return (
    <Flex>
      <Tag
        bg={getBgColor()}
        color={position === 1 ? 'white.80' : 'black.80'}
        width={{ base: 8, md: 10 }}
        height={{ base: 6, md: 8 }}
        display={'flex'}
        justifyContent={'center'}
        rounded="0.25rem"
      >
        {/* need leaderboard rank */}
        {position}
      </Tag>
      <Flex w="1px" h={{ base: 6, md: 8 }} bg={getColorForLine(position)} ml={3}></Flex>
    </Flex>
  );
};
